import React, { useState } from 'react';
import "./footer.scss";
import { Link, useNavigate } from 'react-router-dom';
import Modal from 'react-modal';
import { PRIVACY_POLICY } from '../../constants/privacyPolicy';

const Footer = () => {
    const [openModal, setModal] = useState(false);
    const [content, setContent] = useState('')

    const showModal = () => {
        setModal(true);
        setContent(PRIVACY_POLICY)
    }
    const closeModal = () => {
        setModal(false);
        setContent('')
    }

    return (
        <> <div className="footer-wrapper">
            <div className='section'>
                <img src="/assets/images/ara.png" />
                <div className='text'>
                    <p>Anheuser Busch inbev © 2025 Not for persons under the age of 18.</p>
                    <p>Enjoy Responsibly. Do not share this content with minors.</p>
                    <p>DON'T DRINK AND DRIVE. DON'T DRINK ALCOHOL IF YOU'RE PREGNANT.</p>
                </div>
            </div>
            <div className='links'>
                <Link to={''} onClick={showModal} >PRIVACY POLICY</Link>
                <Link to={'https://www.ab-inbev.com/terms-and-conditions'} target='_blank'>TERMS AND CONDITIONS</Link>
            </div>
        </div>
            <Modal isOpen={openModal}>
                <div className='close-icon' onClick={closeModal}>&#x2715;</div>
                <div dangerouslySetInnerHTML={{ __html: content }} className='privacy-policy-wrapper'>
                </div>
            </Modal></>
    );
}

export default Footer;
